import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ImportExportWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-export-import.sass');

export class ImportExportWidget extends WidgetBase {
    public static _name: string = 'Export/Import';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-export-import';
    public static icon: string = 'transfer';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-export-import'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(ImportExportWidget);
